import 'vue-toastification/dist/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Toast from 'vue-toastification'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import Meta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueTheMask)

Vue.use(Meta, {
  refreshOnceOnNavigation: true
})

Vue.use(Toast, {
  position: 'bottom-left',
  maxToasts: 20,
  newestOnTop: true,
  timeout: 4000,
  toastClassName: 'toast_style'
})

Vue.prototype.showErrorMessage = async (e, msg = 'Error') => {
  let data

  if (e.data instanceof Blob) {
    const str = await new Response(e.data).text()
    data = JSON.parse(str)
  }

  if (e.data instanceof ArrayBuffer) {
    const str = new TextDecoder().decode(e.data)
    data = JSON.parse(str)
  }

  if (!data) data = e.data

  const message = e?.status !== 500 && data?.message ? data?.message : msg
  Vue.prototype.$toast.error(message)
}

export const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
